import SuperFetch from '../../superFetch.js';

class ProductApi {
  /**
   *  [상품 전체 리스트] 상품 전체 리스트 요청하기
   */
  getProductAllList = (data) => SuperFetch.post('/product/list/all', data);

  /**
   *  [상품 승인 리스트] 상품 승인 리스트 요청하기
   */
  getProductApprovalList = (data) => SuperFetch.post('/product/list/approval', data);

  /**
   *  [상품 승인 리스트] 상품 승인 리스트 엑셀 다운로드 요청하기
   */
  getProductApprovalExcelDownload = (data) => SuperFetch.post('/product/list/approval/excel/download', data);

  /**
   *  [상품 금지 리스트] 상품 금지 리스트 요청하기
   */
  getProductBanList = (data) => SuperFetch.post('/product/list/ban', data);

  /**
   *  [상품 금지 리스트] 상품 금지 리스트 엑셀 다운로드 요청하기
   */
  getProductBanExcelDownload = (data) => SuperFetch.post('/product/list/ban/excel/download', data);

  /**
   *  [상품 속성 검수 리스트] 상품 속성 검수 리스트 요청하기
   */
  getProductPropertyRequestList = (data) => SuperFetch.post('/product/list/property/request', data);

  /**
   *  [상품 속성 검수 리스트] 상품 속성 검수 excel 리스트 다운로드 하기
   */
  getProductPropertyRequestExcelDownload = (data) =>
    SuperFetch.post('/product/list/property/request/excel/download', data);

  /**
   *  [상품 리스트] 태그 리스트 가져오기
   */
  getProductTagColumnTagList = (data) => SuperFetch.post('/product/list/all/tag', data);

  /**
   *  [상품 상세] 상품 상세 요청하기
   */
  getProductDetail = (data) => SuperFetch.post('/product/detail', data);

  /**
   *  [상품 상세] 상품 거절 사유 리스트 요청하기
   */
  getRejectReasonList = (data) => SuperFetch.post('/product/detail/info/reject', data);

  /**
   *  [상품 등록] 상품 등록하기 전 필요한 데이터 가져오기
   */
  prepareInsertProduct = (data) => SuperFetch.post('/product/insert/preparation', data);

  /**
   *  [상품 등록] 상점에 따라서 해당 상점의 A/S 정보와 배송정보 가져오기
   */
  getStoreAsAndDeliveryInfo = (data) => SuperFetch.post('/product/insert/preparation/storeInfo', data);

  /**
   *  [상품 등록] 상품 등록하기
   */
  insertProduct = (data) => SuperFetch.post('/product/insert', data);

  /**
   *  [상품 편집] 상품 편집하기
   */
  editProduct = (data) => SuperFetch.post('/product/edit', data);

  /**
   *  [상품 삭제] 상품 삭제하기
   */
  deleteProduct = (data) => SuperFetch.post('/product/delete', data);

  /**
   *  [상품 등록 승인] 상품 승인하기
   */
  permitRegistrationProduct = (data) => SuperFetch.post('/product/registration/permit', data);

  /**
   *  [상품 등록 거절] 상품 승인 거절하기
   */
  rejectRegistrationProduct = (data) => SuperFetch.post('/product/registration/reject', data);

  /**
   *  [상품 판매 금지 승인] 상품 판매 금지 승인 요청하기
   */
  permitBanProduct = (data) => SuperFetch.post('/product/ban/permit', data);

  /**
   *  [상품 판매 금지] 상품 판매 금지 요청하기
   */
  rejectBanProduct = (data) => SuperFetch.post('/product/ban/reject', data);

  /**
   *  [상품 버전] 상품 버전 정보 요청하기
   */
  getProductVersion = (data) => SuperFetch.post('/product/version', data);

  /**
   *  [상품 버전] 상품 버전 상세 요청하기
   */
  getProductVersionDetail = (data) => SuperFetch.post('/product/version/detail', data);

  /**
   *  [상품 상세] 사방넷으로 상품 정보 전송
   */
  sendProductDataToSabangnet = (data) => SuperFetch.post('/product/registration/external', data);

  /**
   *  엑셀 일괄 상품 할인 변경하기
   */
  excelBulkEditProductDiscount = (data) => SuperFetch.post('/product/list/all/update/discount/bulk', data);

  /**
   *  [상품 전체 리스트] 상품 전체 리스트 엑셀 다운로드 요청하기
   */
  getProductAllListExcelDownload = (data) => SuperFetch.post('/product/list/all/excel/download', data);

  /**
   *  [상품 전체 리스트] 상품 전체 리스트 엑셀 다운로드 요청하기
   */
  getProductAllFulfillmentListExcelDownload = (data) =>
    SuperFetch.post('/product/list/all/excel/download/fulfillment', data);

  /**
   *  상품 일괄 편집을 하기전 유효성 테스트 결과 가져오기
   */
  getBulkEditProductValidateResultList = (data) => SuperFetch.post('/product/bulk/edit/detail', data);

  /**
   *  상품 일괄 변경 하기
   */
  bulkEditProduct = (data) => SuperFetch.post('/product/bulk/edit', data);

  /**
   *  상품 태그 리스트 가져오기
   */
  getSearchTagList = (data) => SuperFetch.post('/product/insert/preparation/tag/list', data);

  /**
   *  상품 태그 승인하기
   */
  permitRegistrationProductTag = (data) => SuperFetch.post('/product/detail/tag/permit', data);

  /**
   *  상품 태그 거절하기
   */
  rejectRegistrationProductTag = (data) => SuperFetch.post('/product/detail/tag/reject', data);

  /**
   *  상품 속성 승인하기
   */
  permitRegistrationProductProperty = (data) => SuperFetch.post('/product/detail/property/permit', data);

  /**
   *  상품 속성 거절하기
   */
  rejectRegistrationProductProperty = (data) => SuperFetch.post('/product/detail/property/reject', data);
}

export default new ProductApi();
